import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
const Link = styled(RouterLink) `
  text-decoration: none;
  cursor: pointer;
  transition: color 150ms ease;
  &,
  &:visited {
    color: ${({ variant, theme }) => (variant === 'orange' ? theme.colors.main : theme.colors.link100)};
  }
  &:hover,
  &:focus {
    color: ${({ variant, theme }) => (variant === 'orange' ? theme.colors.mainDark : theme.colors.link120_1)};
    text-decoration: none;
  }
`;
export default React.memo(Link);
